export default __webpack_public_path__ + "static/media/ChevronColUp.6e36cebb.svg";